export const USER_ROLES = {
  admin: {
    id: 1,
  },
  regular: {
    id: 2,
  },
  custom: {
    id: 3,
  },
};

export const PERMISSIONS = {
  GROWTH: 'growth.modify',
  TRANSACTIONAL_MAIL: 'mail.transactional',
  UNSUBSCRIBABLE_EDITOR: 'bypass_unsubscription.modify',
  RATE_LIMIT: 'mail.rate_limit.modify',
};

export const doesUserHavePermission = (permission, userPermissions = []) => {
  return userPermissions.includes(permission);
};
